<div class="date-picker-container">
    <input class="vox-text-field date-picker-input" id="date" [(ngModel)]="date" ngbDatepicker #d="ngbDatepicker"
        (dateSelect)="onProcess($event)"
        [placeholder]="placeholder"
        [minDate]="minDate" [maxDate]="maxDate" [dayTemplate]="customDay" placement="bottom-left"
        (click)="d.toggle()"
        readonly
    >
    <i class="vox-text-field__icon vox-text-field__icon_black icon-small-alert date-picker-input-icon"></i>
    <div class="custom-date__btn date-picker-toggle-btn" (click)="d.toggle()">
        <i class="icon-small-calendar-schedule date-picker-toggle-btn-icon"></i>
    </div>
</div>

<ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled"
    let-focused="focused">
    <div class="custom-day" [class.day-selected]="selected" [class.text-muted]="disabled">
        {{ date.day }}
    </div>
</ng-template>